module.exports = __webpack_public_path__ + "img/mini-025.f9234d97.jpg";